/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './customer-navbar.component.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/router';
import * as i3 from '@angular/common';
import * as i4 from '../custom-menu/custom-menu.component.ngfactory';
import * as i5 from '../../../../app/shared/custom-menu/custom-menu.component';
import * as i6 from '../../../../app/shared/settings.service';
import * as i7 from '../../../../app/auth/current-user';
import * as i8 from '../logged-in-user-widget/logged-in-user-widget.component.ngfactory';
import * as i9 from '../../../../app/shared/logged-in-user-widget/logged-in-user-widget.component';
import * as i10 from '../../../../app/auth/auth.service';
import * as i11 from '../../../../app/shared/customer-navbar/customer-navbar.component';
const styles_CustomerNavbarComponent:any[] = [i0.styles];
export const RenderType_CustomerNavbarComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_CustomerNavbarComponent,data:{}});
function View_CustomerNavbarComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),0,'img',[['alt',
      'Logo'],['class','logo']],[[8,'src',4]],(null as any),(null as any),(null as any),
      (null as any)))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.settings.get('branding.hc_logo');
    _ck(_v,0,0,currVal_0);
  });
}
function View_CustomerNavbarComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'div',[['class',
      'text-logo']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['','']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.settings.get('branding.site_name');
    _ck(_v,1,0,currVal_0);
  });
}
export function View_CustomerNavbarComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),21,'nav',[['class',
      'navbar']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          18,'div',[['class','nav-content']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),8,'a',[['class','nav-group logo-group left'],
          ['routerLink','/']],[[1,'target',0],[8,'href',4]],[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,5).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(671744,(null as any),0,i2.RouterLinkWithHref,
          [i2.Router,i2.ActivatedRoute,i3.LocationStrategy],{routerLink:[0,'routerLink']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n            '])),(_l()(),
          i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CustomerNavbarComponent_1)),
      i1.ɵdid(16384,(null as any),0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n            '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CustomerNavbarComponent_2)),
      i1.ɵdid(16384,(null as any),0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),
          i1.ɵted((null as any),['\n\n        '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),5,'custom-menu',[['class','nav-group right'],['position','header']],
          [[2,'hidden',(null as any)]],(null as any),(null as any),i4.View_CustomMenuComponent_0,
          i4.RenderType_CustomMenuComponent)),i1.ɵdid(245760,(null as any),0,i5.CustomMenuComponent,
          [i6.SettingsService,i7.CurrentUser],{position:[0,'position']},(null as any)),
      (_l()(),i1.ɵted(0,['\n            '])),(_l()(),i1.ɵeld(0,(null as any),0,1,'logged-in-user-widget',
          [['class','nav-item']],(null as any),(null as any),(null as any),i8.View_LoggedInUserWidgetComponent_0,
          i8.RenderType_LoggedInUserWidgetComponent)),i1.ɵdid(49152,(null as any),
          0,i9.LoggedInUserWidgetComponent,[i7.CurrentUser,i10.AuthService],(null as any),
          (null as any)),(_l()(),i1.ɵted(0,['\n        '])),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i11.CustomerNavbarComponent = _v.component;
    const currVal_2:any = '/';
    _ck(_v,5,0,currVal_2);
    const currVal_3:any = _co.settings.has('branding.hc_logo');
    _ck(_v,8,0,currVal_3);
    const currVal_4:boolean = !_co.settings.has('branding.hc_logo');
    _ck(_v,11,0,currVal_4);
    const currVal_6:any = 'header';
    _ck(_v,15,0,currVal_6);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,5).target;
    const currVal_1:any = i1.ɵnov(_v,5).href;
    _ck(_v,4,0,currVal_0,currVal_1);
    const currVal_5:any = i1.ɵnov(_v,15).shouldHide;
    _ck(_v,14,0,currVal_5);
  });
}
export function View_CustomerNavbarComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'customer-navbar',
      ([] as any[]),(null as any),(null as any),(null as any),View_CustomerNavbarComponent_0,
      RenderType_CustomerNavbarComponent)),i1.ɵdid(49152,(null as any),0,i11.CustomerNavbarComponent,
      [i7.CurrentUser,i6.SettingsService],(null as any),(null as any))],(null as any),
      (null as any));
}
export const CustomerNavbarComponentNgFactory:i1.ComponentFactory<i11.CustomerNavbarComponent> = i1.ɵccf('customer-navbar',
    i11.CustomerNavbarComponent,View_CustomerNavbarComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// E:/wamp64/www/helpdesk/client/src/$$_gendir/app/shared/customer-navbar/customer-navbar.component.ngfactory.ts